import AdultSequenceItem from "../../../../ootr/inventory/items/AdultSequenceItem";
import BiggoronSwordItem from "../../../../ootr/inventory/items/BiggoronSwordItem";
import BombchusItem from "../../../../ootr/inventory/items/BombchusItem";
import BombItem from "../../../../ootr/inventory/items/BombItem";
import BoomrangItem from "../../../../ootr/inventory/items/BoomrangItem";
import BowItem from "../../../../ootr/inventory/items/BowItem";
import ChildSequenceItem from "../../../../ootr/inventory/items/ChildSequenceItem";
import DekuNutItem from "../../../../ootr/inventory/items/DekuNutsItem";
import DekuShieldItem from "../../../../ootr/inventory/items/DekuShieldItem";
import DekuStickItem from "../../../../ootr/inventory/items/DekuStickItem";
import DinsFireItem from "../../../../ootr/inventory/items/DinsFireItem";
import FaroresWindItem from "../../../../ootr/inventory/items/FaroresWindItem";
import FireArrowItem from "../../../../ootr/inventory/items/FireArrowItem";
import GerudoCardItem from "../../../../ootr/inventory/items/GerudoCardItem";
import GoMode from "../../../../ootr/inventory/items/GoMode";
import GoronTunicItem from "../../../../ootr/inventory/items/GoronTunicItem";
import HookshotItem from "../../../../ootr/inventory/items/HookshotItem";
import HoverBootsItem from "../../../../ootr/inventory/items/HoverBootsItem";
import HylianShieldItem from "../../../../ootr/inventory/items/HylianShieldItem";
import IceArrowItem from "../../../../ootr/inventory/items/IceArrowItem";
import IronBootsItem from "../../../../ootr/inventory/items/IronBootsItem";
import KokiriBootsItem from "../../../../ootr/inventory/items/KokiriBootsItem";
import KokiriSwordItem from "../../../../ootr/inventory/items/KokiriSwordItem";
import KokiriTunicItem from "../../../../ootr/inventory/items/KokiriTunicItem";
import LensOfTruthItem from "../../../../ootr/inventory/items/LensOfTruthItem";
import LightArrowItem from "../../../../ootr/inventory/items/LightArrowItem";
import MagicBeansItem from "../../../../ootr/inventory/items/MagicBeansItem";
import MagicItem from "../../../../ootr/inventory/items/MagicItem";
import MasterSwordItem from "../../../../ootr/inventory/items/MasterSwordItem";
import MegatonHammerItem from "../../../../ootr/inventory/items/MegatonHammerItem";
import MirrorShieldItem from "../../../../ootr/inventory/items/MirrorShieldItem";
import MultiBottleItem from "../../../../ootr/inventory/items/MultiBottleItem";
import NayrusLoveItem from "../../../../ootr/inventory/items/NayrusLoveItem";
import OcarinaItem from "../../../../ootr/inventory/items/OcarinaItem";
import RutoLetterItem from "../../../../ootr/inventory/items/RutoLetterBottle";
import ScaleItem from "../../../../ootr/inventory/items/ScaleItem";
import SlingshotItem from "../../../../ootr/inventory/items/SlingshotItem";
import StoneOfAgonyItem from "../../../../ootr/inventory/items/StoneOfAgonyItem";
import StrengthItem from "../../../../ootr/inventory/items/StrengthItem";
import TokenItemCounter from "../../../../ootr/inventory/items/TokenCounterItem";
import WalletItem from "../../../../ootr/inventory/items/WalletItem";
import ZoraTunicItem from "../../../../ootr/inventory/items/ZoraTunicItem";
import FireMedallionItem from "../../../../ootr/inventory/medallions/FireMedallionItem";
import ForestMedallionItem from "../../../../ootr/inventory/medallions/ForestMedallionItem";
import GoronRubyItem from "../../../../ootr/inventory/medallions/GoronRubyItem";
import KokiriEmeraldItem from "../../../../ootr/inventory/medallions/KokiriEmeraldItem";
import LightMedallionItem from "../../../../ootr/inventory/medallions/LightMedallionItem";
import ShadowMedallionItem from "../../../../ootr/inventory/medallions/ShadowMedallionItem";
import SpiritMedallionItem from "../../../../ootr/inventory/medallions/SpiritMedallionItem";
import WaterMedallionItem from "../../../../ootr/inventory/medallions/WaterMedallionItem";
import ZoraSapphireItem from "../../../../ootr/inventory/medallions/ZoraSapphireItem";




export const OoTClassicItemList = [
    DekuStickItem,
    DekuNutItem,
    BombItem,
    BowItem,
    FireArrowItem,
    DinsFireItem,
    SlingshotItem,
    OcarinaItem,
    BombchusItem,
    HookshotItem,
    IceArrowItem,
    FaroresWindItem,
    BoomrangItem,
    LensOfTruthItem,
    MagicBeansItem,
    MegatonHammerItem,
    LightArrowItem,
    NayrusLoveItem,
    RutoLetterItem,
    MultiBottleItem,
    MultiBottleItem,
    MultiBottleItem,
    ChildSequenceItem,
    AdultSequenceItem,
    KokiriSwordItem,
    MasterSwordItem,
    BiggoronSwordItem,
    GoMode,
    TokenItemCounter,
    () => null,
    DekuShieldItem,
    HylianShieldItem,
    MirrorShieldItem,
    MagicItem,
    WalletItem,
    GerudoCardItem,
    KokiriTunicItem,
    GoronTunicItem,
    ZoraTunicItem,
    StoneOfAgonyItem,
    ScaleItem,
    StrengthItem,
    KokiriBootsItem,
    IronBootsItem,
    HoverBootsItem,

]


export const OoTReduceItemList = [
    SlingshotItem,
    BombItem,
    StrengthItem,
    HookshotItem,
    MagicItem,
    FireArrowItem,
    DinsFireItem,
    RutoLetterItem,
    ChildSequenceItem,

    BoomrangItem,
    BombchusItem,
    MegatonHammerItem,
    BowItem,
    LensOfTruthItem,
    LightArrowItem,
    FaroresWindItem,
    MultiBottleItem,
    AdultSequenceItem,

    KokiriSwordItem,
    HylianShieldItem,
    GoronTunicItem,
    IronBootsItem,
    OcarinaItem,
    IceArrowItem,
    NayrusLoveItem,
    ScaleItem,
    WalletItem,
 
    BiggoronSwordItem,
    MirrorShieldItem,
    ZoraTunicItem,
    HoverBootsItem,
    GerudoCardItem,
    MagicBeansItem,
    TokenItemCounter,
    GoMode
]


export const ChildReward = [
    KokiriEmeraldItem,
    GoronRubyItem,
    ZoraSapphireItem,

]
export const AdultRewards = [

    ForestMedallionItem,
    FireMedallionItem,
    WaterMedallionItem,
    ShadowMedallionItem,
    SpiritMedallionItem,
    LightMedallionItem
]


